import React from 'react';
import PropTypes from 'prop-types';
import { classes } from '../../Tabs.st.css.js';
const SideContent = ({ content }) => content ? (React.createElement("div", { "data-content": "true", className: classes.sideContent }, content)) : null;
SideContent.propTypes = {
    content: PropTypes.node,
};
export default SideContent;
//# sourceMappingURL=index.js.map